/**
 * Find the iframe srouce from oEmbed HTML string
 * So we can render the <a> href for SEO
 * @param {String} embedHtml
 */
export const getVideoSource = embedHtml => {
    const pattern = RegExp('src="(.*?)"', "g");
    const found = pattern.exec(embedHtml);
    return found && found.length > 1 ? found[1] : "";
};

/**
 * Update the iframe source to include the `autoplay` query param for a video embed
 * @param {String} embedHtml
 */
export const makeAutoplaySource = embedHtml => {
    if (!embedHtml) return null;
    const pattern = /src="https(.*?)(\?)(.*?)"/;
    return embedHtml.replace(pattern, 'src="https$1?$3"');
};

let hasWistiaScriptLoaded = false; // Track whether script has been added

export const stripSecurityAttributes = (embedCode) => {
    if (!embedCode) return "";

    // Check if the embed code is from Wistia
    const isWistia = embedCode.includes("wistia");

    // Remove security restrictions
    embedCode = embedCode.replace('sandbox="allow-scripts"', "");
    embedCode = embedCode.replace('security="restricted"', "");
    embedCode = embedCode.replace('class="wp-embedded-content"','class="wp-embedded-content wistia_embed" name="wistia_embed" allow="fullscreen" allowfullscreen msallowfullscreen');

    // Inject Wistia script directly into the embed code (only once)
    if (isWistia && !hasWistiaScriptLoaded) {
        hasWistiaScriptLoaded = true; // Mark script as loaded
        embedCode += `<script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>`;
    }

    return embedCode;
};
